const TYPE = 'attr.customTextAttribute.parentRelationship';
function create(opts) {
  const {
    attrName,
    objectType
  } = opts || {};
  return {
    type: TYPE,
    attrName,
    objectType
  };
}
export default {
  TYPE,
  create
};